import { IExportPlugin, PluginType } from '@/version-types';
import { ClipboardPlugin } from './controller';
import { ClipboardPluginDependency } from './dependency';

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 3,
    name: 'clipboard',

    createInstance({ identity }) {
        return [
            { key: 'ClipboardPluginDependency', value: new ClipboardPluginDependency(identity) },
            { key: 'ClipboardPlugin', value: new ClipboardPlugin(identity) },
        ];
    },
};

export default exportPlugin;
